module.exports = __webpack_public_path__ + "static/media/spinner.013c5d37.svg";